import { render, staticRenderFns } from "./DefaultWidget.vue?vue&type=template&id=1bf84a78&scoped=true"
import script from "./DefaultWidget.vue?vue&type=script&lang=js"
export * from "./DefaultWidget.vue?vue&type=script&lang=js"
import style0 from "./DefaultWidget.vue?vue&type=style&index=0&id=1bf84a78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf84a78",
  null
  
)

export default component.exports